import { Component, inject, OnInit } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LOCALE } from '@shared/*';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { FirebaseMessagingHandlerComponent } from './components/firebase-messaging/firebase-messaging-handler/firebase-messaging-handler.component';
import { UnsupportedBrowserComponent } from './components/common/error-response/unsupported-browser/unsupported-browser.component';

@Component({
  selector: 'app-root-new',
  standalone: true,
  imports: [HeaderComponent, RouterOutlet, ZenithComponentsModule, FirebaseMessagingHandlerComponent, UnsupportedBrowserComponent],
  templateUrl: './new-app.component.html'
})
export class NewAppComponent implements OnInit {
  private readonly translateService = inject(TranslateService);

  ngOnInit(): void {
    this.translateService.setDefaultLang(DEFAULT_LOCALE);
  }
}
